import { Component, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-beneficiario-tel',
  templateUrl: './beneficiario-tel.component.html',
  styleUrls: ['./beneficiario-tel.component.scss']
})
export class BeneficiarioTelComponent implements OnInit {

  public telefono: string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private _informe: InformesService, private _snackBar: MatSnackBar, private dialogRef: MatDialogRef<BeneficiarioTelComponent>) { }

  ngOnInit() {
    this.telefono = this.datos.benef_telefono;
  }

  public guardarTelefono(){

    let response:Object = {
      respuesta: true,
      indice: this.datos.indice,
      nuevoTelefono: this.telefono
    }

    this.dialogRef.close(response);

    /* this._informe.ActualizarBenefTel(this.datos.documento_benef, this.telefono).subscribe((data: any) => {
      this._snackBar.open('Se ha actulizado el teléfono del beneficiario', 'Aceptar', {
        duration: 2000
      })
      this.dialogRef.close(response);
    }) */
  }
}